<template>
    <footer>
      <p>&copy; 2024 Brasilico. Todos os direitos reservados.</p>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterComponent',
  };
  </script>
  
  <style scoped>
  footer {
    background-color: #003366;
    color: white;
    padding: 10px;
    text-align: center;
    width: 100%;
    position: fixed;
    bottom: 0;
}
  </style>
  